import React, { Component } from 'react';
import styled from 'styled-components';
import { getTheme } from '../../global/utils';

const Header = styled.div`
  padding: ${getTheme('padding', 'verticalPage')}
    ${getTheme('padding', 'horizontalPage')};
`;

class PageHeading extends Component {
  render() {
    return (
      <Header className={this.props.className}>{this.props.children}</Header>
    );
  }
}

export default PageHeading;



// WEBPACK FOOTER //
// ./src/components/shared/PageHeading.js